import React, { useContext } from "react";

import { ElementState, Preview } from "@creatomate/preview";
import { Button } from "@culturehq/components";
import deleteElement from "../utils/creatomate/deleteElement";
import { StoryModalContext } from "../contexts/StoryContext";

interface DeleteButtonProps {
  element?: ElementState;
  onDelete?: () => void;
  preview: Preview;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({ element, onDelete, preview }) => {
  const { onSelectStories, selectedStories } = useContext(StoryModalContext);

  const handleDelete = async () => {
    await deleteElement(preview, element?.source?.id);
    if (onDelete) onDelete();
    if (selectedStories.length > 0) {
      onSelectStories(selectedStories.filter(
        oldStory => oldStory.creatomateId !== element?.source?.id
      ));
    }
  };

  return (
    <Button className="Trash-Icon" icon="trash-a-outlined" onClick={handleDelete} />
  );
};

export default DeleteButton;
